import { Controller } from 'stimulus'

export default class extends Controller {
  static values = {
    latitude: String,
    longitude: String
  }

  click () {
    dispatchEvent(
      new CustomEvent('eventClicked',
        {
          detail: {
            coordinates: [this.latitudeValue, this.longitudeValue]
          }
        })
    )
  }
}
